import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';

import { clearAlert } from '../../store/ducks/alert';

export class AlertBar extends React.Component {
  handleClose() {
    const { dispatch } = this.props;

    dispatch(clearAlert());
  }

  render() {
    const { alert } = this.props;

    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        { alert.message !== null && (
          <Alert
            className="mb-5"
            variant={alert.variant}
            onClose={() => this.handleClose()}
            dismissible
          >
            <FontAwesomeIcon icon={alert.icon} size="lg" />
            <div className="d-inline-block pl-2">{ alert.message }</div>
          </Alert>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
  };
}

AlertBar.defaultProps = {
  alert: {
    variant: null,
    icon: null,
    message: null,
  },
};

AlertBar.propTypes = {
  alert: PropTypes.shape({
    variant: PropTypes.string,
    icon: PropTypes.string,
    message: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AlertBar);
